import React from "react";
import { PanelBottomOpen, SquareX } from "lucide-react";

const SunroofToggle = ({ hasSunroof, setHasSunroof }) => {
    // Styles for compact, rounded, aesthetic rectangles
    const containerStyle = {
        display: "flex",
        width: "100%",
        gap: "14px",
        marginBottom: "1px",
        justifyContent: "space-between",
        alignItems: "center"
    };

    const toggleStyle = (type) => ({
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        background: hasSunroof === type ? "#fff2f2" : "#fcfcfc",
        border: hasSunroof === type ? "2.5px solid #EC6466" : "2.5px solid #e3e3e3",
        borderRadius: "22px",
        padding: "16px 0 12px 0",
        boxShadow: hasSunroof === type ? "0 2px 8px rgba(236,100,102,0.08)" : "0 2px 8px rgba(120,120,120,0.05)",
        cursor: "pointer",
        minWidth: 0,
        transition: "all .2s"
    });

    const iconStyle = (type) => ({
        marginBottom: "6px",
        color: hasSunroof === type ? "#EC6466" : "#888",
        transition: "color .2s"
    });

    // Verdana: highly readable, small UI font
    const labelStyle = (type) => ({
        fontFamily: "Lato, Geneva, sans-serif",
        fontSize: "0.72rem",
        fontWeight: hasSunroof === type ? 600 : 500,
        color: hasSunroof === type ? "#EC6466" : "#444",
        marginTop: "1px",
        letterSpacing: ".2px",
        textAlign: "center",
        userSelect: "none"
    });

    const headingStyle = {
        fontFamily: "Lato",
        fontSize: "12px",
        fontWeight: 500,
        color: "#B0B0B0",
        marginBottom: "12px",
        letterSpacing: ".3px"
    };

    return (
        <div>
            <div style={headingStyle}>Does your vehicle have a sunroof?</div>
            <div style={containerStyle}>
                <div
                    style={toggleStyle(true)}
                    onClick={() => setHasSunroof(true)}
                    data-testid="sunroof-yes-toggle"
                >
                    <PanelBottomOpen
                        size={38}
                        strokeWidth={1.5}
                        style={iconStyle(true)}
                    />
                    <div style={labelStyle(true)}>Yes, has sunroof</div>
                </div>
                <div
                    style={toggleStyle(false)}
                    onClick={() => setHasSunroof(false)}
                    data-testid="sunroof-no-toggle"
                >
                    <SquareX
                        size={38}
                        strokeWidth={1.5}
                        style={iconStyle(false)}
                    />
                    <div style={labelStyle(false)}>No sunroof</div>
                </div>
            </div>
        </div>
    );
};

export default SunroofToggle;